<template>
    <div class="absolute top-0 right-0 left-0 bottom-0 flex justify-center items-center text-white z-30"><fa-icon :icon="['far', 'spinner']" size="3x" spin></fa-icon></div>
</template>

<style scoped>
.absolute {
    background-color: #922643;
}
</style>